/*
 * 詳細画面システムコード入力定義コンポーネント
 */
<template>
	<tr class="tr-td-control">
		<td class="td-dataname text_code_area">
			<div><!--
				-->{{r_title}}
				<div v-if="edit_right && r_is_require" class="layout-right">
					<font class="text-red">＊</font>
				</div>
				<div v-if="m_isEdit" class="layout-right">
					<font class="text-red">*</font>
				</div>
			</div>
		</td>
		<td class="td-data text_code_area">
			<el-form v-if="edit_right" :model="m_ruleForm" :rules="m_validationCode" ref="valid_target">
				<el-form-item prop="code" class="text_code_area" >
					<c-selectitem
						:r_disabled="r_disabled"
						class="detail-item-default"
						:r_list="disp_systemCodeList" 
						v-model="m_ruleForm.code" 
						:r_select_class="createEditClassType(m_ruleForm.code)"
						@event_change="onChangeSystemCode"
					>
					</c-selectitem>
				</el-form-item>
			</el-form >
			<div v-else>
				<font :class="{'text-red':m_isEdit}"> {{disp_systemCode}}</font>
			</div>
		</td >
	</tr>
</template>
<script>
	/**
	 * 詳細画面全行入力時の文字サイズ入力定義コンポーネント.<br>
	 * @module js/parts_unit/TR/editSystemCode.vue
	 * @example
	 * 	<c-edittext
	 * 		:r_messages = "r_messages" 
	 * 		:r_settings = "r_settings" 
	 * 		:r_title = "r_messages.search_char_name" 
	 * 		:r_func_cl="r_settings.charsize_func_cl"
	 * 		v-model="m_info.disp_text" 
	 * 		@keyup="onKeyup" >
	 * 	</c-edittext>
	 **/

	/**
	 * props 引数
	 * @param {string[]} r_messages - 表示文言
	 * @param {string[]} r_settings - 初期設定値
	 * @param {object} info - 編集するデータ
	 **/
	 export default {
		mixins: [
			require('js/common/vuex/systemcode/read.mixin.vue'),
			require('js/common/Edit2.mixin.vue'),
			require('js/common/trEdit.mixin.vue'),
			// バリデーションミックスイン
			require('js/common/validate/edit.mixin.vue'),

		],
		props:{
			'r_messages': {},
			'r_settings': {},
			'r_title': String,
			'r_func_cl': {},
			'r_exc_code': {
				type:Array,
				default: function() {
					return [];
				}
			},	// 除外するシステムコード
			'r_disabled': {
				type:Boolean,
				default:false
			},
			'value': {},
			'r_isChange': {
				type:Boolean,
				default: true,
			},
			// ユーザーの編集権限をチェックするか
			'r_check_editable': {
				type:Boolean,
				default: true,
			},
			'r_is_use_system_label': {
				type: Boolean,
				default: false,
			},
		},
		data: function (){
			return{
				m_ruleForm: {code:this.value},
				m_validationCode:{
					code: [
						{ required: this.r_is_require, message: this.r_messages.required,trigger:'no' },
						{
							validator: (rule, value, callback) => {
								var errMessage = "";//target.manager.validationcode(value,this.r_code_max,this.r_code_min);
								
								if ( errMessage.length > 0 ) {
									callback(new Error(errMessage));
								} else {
									callback();
								}
							},
							trigger: ''
						}
					],
				},
			}
		},
		created: function() {
			this.m_isChange = false;
		},
		/**
		 * @prop {object} disp_systemCodeList - 
		 * @prop {object} disp_systemCode - 
		 * @instance
		 **/
		computed: {
			disp_systemCodeList:function(){
				if(this.r_exc_code.length == 0) {
					// 除外コードが設定されていない
					// return this.getSystemcodeList(this.r_func_cl);
					let disp = [];
					let system_codes = this.getSystemcodeList(this.r_func_cl);
					for (var system_key in system_codes) {
						if (system_codes[system_key] && system_codes[system_key]['label']) {
							if (this.r_is_use_system_label) {
								system_codes[system_key]['label'] = system_codes[system_key]['label'];
							} else {
								system_codes[system_key]['label'] = this.r_messages[system_codes[system_key]['label']];
							}
							disp.push(system_codes[system_key]);
						}
					}
					return disp;
				} else {
					// 除外コードが設定されている
					let disp = [];
					let system_codes = this.getSystemcodeList(this.r_func_cl);
					for(var system_key in system_codes){
						console.log(system_codes[system_key]['value']);
						let is_exc = false;
						for(var exc_key in this.r_exc_code){
							console.log(this.r_exc_code[exc_key]);
							if( this.r_exc_code[exc_key] == system_codes[system_key]['value']) {
								is_exc = true;
								break;
							}
						}
						if(is_exc == false) {
							disp.push(system_codes[system_key]);
						}
					}
					return disp;
				}
			},
			disp_systemCode:function(){
				var label = this.getSystemcodeListLabel(this.r_func_cl,this.m_ruleForm.code);
//				console.log("[ systemcode_disp ]");
//				console.log(label);
				if (label) {
					return label;
				}
				return "";
			},
			// 編集可能か
			edit_right:function() {
				if (!this.r_check_editable) {
					return true;
				}
				if (this.r_settings.edit_right) {
					return true;
				}
				return false;
			},
		},
		watch:{
			value: function(val){
				this.m_ruleForm.code = val;
			},
		},
		methods: {
			/**
			 * キーアップイベント <br>
			 * ******* 内部処理 *******<br>
			 * keyupでイベントを受け取り、親にkeyupイベントを飛ばす。 <br>
			 *
			 * @function onKeyup
			 * @param {object} e - イベントオブジェクト
			 * @instance
			 */
			onKeyup: function( e ){
			 	this.$emit('keyup', e);
			},
			onChangeSystemCode: function(val, old) {
				this.m_isChange = this.r_isChange;
				this.$emit('input', this.m_ruleForm.code)
				this.$emit("event_change",val,old);
			},
			/**
			 * 変更フラグリセット <br>
			 * ******* 内部処理 *******<br>
			 *  <br>
			 *
			 * @function  setUpdate
			 * @param {bool} is - 変更フラグ
			 * @instance
			 */
			setUpdate: function( is ){
				this.m_isChange = is;
			},
		},
		/**
		 * ファイル内で使用しているコンポーネント <br>
		 * cはグローバルコンポーネント(宣言は親のjsファイルで行っている)<br>
		 * myはローカルコンポーネント <br>
		 * @prop {component} c-selectname - Vuexデータリスト
		 * @prop {component} c-vuexlabel - ページネーションコンポーネント
		 * @prop {component} c-btnhelpmessage - ヘルプボタン
		 * @instance
		 **/
		components: {
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/TR/editSystemCode.vue